module.exports = __webpack_public_path__ + "img/2.6724d525.png";